import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {UrbisoftActionItem, UrbisoftToolbarConfig} from '../../interfaces/urbisoft-main-structure-config.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output()
  toggleSideBar = new EventEmitter<boolean>();
  @Output() logout: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() toolbarConfig: UrbisoftToolbarConfig;
  sideBarOpened = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  public openSideBar(): void {
    this.sideBarOpened = !this.sideBarOpened;
    this.toggleSideBar.next(this.sideBarOpened);
  }

  public action(item: UrbisoftActionItem): void {
    if (item.actionOnClick) {
      item.actionOnClick();
    }
  }

  public logoutAction(): void {
    this.logout.emit(true);
  }

  public closeSidebar(): void {
    // TODO CHANGE THIS
    // this.sideBarOpened = false;
    // this.toggleSideBar.next(false);
  }
}
